import { Link } from 'react-router-dom';

const SEP = (
  <span className="text-white/35 text-xs shrink-0 px-0.5" aria-hidden>
    &lt;
  </span>
);

/**
 * Nav trail: linked ancestors (small) then `<` then current page title (large).
 * Example: Buildings &lt; Fiore 2 &lt; SS Units
 */
export default function BreadcrumbTrail({ items, currentTitle }) {
  const ancestors = Array.isArray(items) ? items : [];
  const hasAncestors = ancestors.length > 0;
  if (!hasAncestors && !currentTitle) return null;

  return (
    <nav
      className="flex flex-wrap items-center gap-0.5 sm:gap-1 min-w-0 leading-snug"
      aria-label="Breadcrumb"
    >
      {ancestors.map((item, i) => (
        <span key={`${item.to || item.label}-${i}`} className="flex items-center gap-0.5 sm:gap-1 min-w-0">
          {i > 0 && SEP}
          {item.to ? (
            <Link
              to={item.to}
              className="text-[11px] sm:text-xs text-white/65 hover:text-white truncate max-w-[8rem] sm:max-w-[12rem]"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-[11px] sm:text-xs text-white/65 truncate max-w-[8rem] sm:max-w-[12rem]">
              {item.label}
            </span>
          )}
        </span>
      ))}
      {currentTitle != null && currentTitle !== '' && (
        <span className="flex items-center gap-0.5 sm:gap-1 min-w-0">
          {hasAncestors && SEP}
          <h1 className="text-lg sm:text-xl font-bold tracking-tight text-white min-w-0 leading-snug break-words whitespace-normal">
            {currentTitle}
          </h1>
        </span>
      )}
    </nav>
  );
}
